import React from 'react';
import { SwitchProps } from 'antd';
import { StyledSwitch } from './SwitchStyles';

export type TSwitchProps = SwitchProps;

const Switch = (props: TSwitchProps): JSX.Element => <StyledSwitch {...props} />;

export default Switch;
